import React from "react";
import "../App.css";

function Header() {
    return <>
    <nav className="nav">
    <div className="logo">News<span>Bot</span></div>
      <a href="google.com">Home</a>
        <a href="google.com">About</a>
      <a href="google.com">News</a>
      <a href="google.com">Contact</a>
    </nav>
    <div className="header">
    </div>
    </>
} 


export default Header;

